import {
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  IconButton,
  LabelValueList,
  PencilAltIcon,
  TimesIcon,
  useModal,
  useRouter,
} from '@forgeglobal/design-framework'
import { PlatformSettingsModal } from 'components/issuers/PlatformSettingsModal'
import { formatSharePrice } from 'util/NumberUtils'
import { useIssuerPlatformSettingsQuery } from 'graphql/bindings/AdminBindings'
import React from 'react'

export const PlatformSettings: React.FC = () => {
  const { match } = useRouter<{ id: string }>()
  const issuerId = match.params.id
  const { data } = useIssuerPlatformSettingsQuery({ variables: { issuerId: issuerId } })

  const company = data?.account.issuer_account?.company

  const [showModal, hideModal] = useModal(() => {
    return <PlatformSettingsModal hideModal={hideModal} issuerId={issuerId} />
  }, [issuerId])

  return (
    <Card>
      <CardHeader
        title="Platform Settings"
        action={
          <IconButton onClick={showModal}>
            <PencilAltIcon />
          </IconButton>
        }
      />
      <CardContent>
        <LabelValueList
          items={[
            {
              label: 'Implied Bid (price per share)',
              value: company?.default_share_price_shareholder
                ? formatSharePrice(company.default_share_price_shareholder)
                : '-',
              isEmpty: !company?.default_share_price_shareholder,
            },
            {
              label: 'Implied Ask (price per share)',
              value: company?.default_share_price_investor
                ? formatSharePrice(company.default_share_price_investor)
                : '-',
              isEmpty: !company?.default_share_price_investor,
            },
            {
              label: 'Show Pricing Data',
              value: company?.show_pricing_data ? (
                <div style={{ pointerEvents: 'none' }}>
                  <Checkbox checked />
                </div>
              ) : (
                <div style={{ margin: '0 9px' }}>
                  <TimesIcon />
                </div>
              ),
            },
            {
              label: 'Featured',
              value: company?.featured ? (
                <div style={{ pointerEvents: 'none' }}>
                  <Checkbox checked />
                </div>
              ) : (
                <div style={{ margin: '0 9px' }}>
                  <TimesIcon />
                </div>
              ),
            },
          ]}
        />
      </CardContent>
    </Card>
  )
}
